
import React from 'react';
import { TabsContent } from "@/components/ui/tabs";
import UserStatisticsCard from "../UserStatisticsCard";
import UserGrowthChart from "../UserGrowthChart";

interface UsersTabProps {
  isLoading: boolean;
  userStatisticsData: {
    totalUsers?: number;
    totalAdmins?: number;
    totalStandardUsers?: number;
    mostActiveUser?: string;
    mostActiveDistance?: number;
    averageDistancePerUser?: number;
    averageRidesPerUser?: number;
    averageOffsetDistancePerUser?: number;
  };
  userGrowthData: any[];
}

const UsersTab: React.FC<UsersTabProps> = ({ 
  isLoading, 
  userStatisticsData,
  userGrowthData 
}) => {
  return (
    <TabsContent value="users" className="space-y-6">
      <div className="grid gap-6 md:grid-cols-2">
        <UserStatisticsCard
          isLoading={isLoading}
          data={userStatisticsData}
        />
        <UserGrowthChart
          isLoading={isLoading}
          data={userGrowthData || []}
        />
      </div>
    </TabsContent>
  );
};

export default UsersTab;
